(() => {
  const root = document.documentElement;

  const updateButton = (button) => {
    const media = button.closest('[data-techno-card-media]');
    if (!media) return;
    const opposite = media.classList.contains('is-preview-opposite');
    const dark = root.dataset.colorMode === 'dark';
    button.setAttribute('aria-pressed', String(opposite));
    button.setAttribute('aria-label', opposite
      ? (dark ? 'Return to illuminated product image' : 'Return to lights-off product image')
      : (dark ? 'Preview lights off' : 'Preview lights on'));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-techno-card-light-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const media = button.closest('[data-techno-card-media]');
    if (!media) return;
    media.classList.toggle('is-preview-opposite');
    updateButton(button);
  });

  document.addEventListener('techno:modechange', () => {
    document.querySelectorAll('[data-techno-card-media]').forEach((media) => media.classList.remove('is-preview-opposite'));
    document.querySelectorAll('[data-techno-card-light-toggle]').forEach(updateButton);
  });

  const init = () => document.querySelectorAll('[data-techno-card-light-toggle]').forEach(updateButton);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
